<div class="container mt-4 fixed-min">
  <h1 class="h1 title-blue-h1-cap mt-2">Calendarizaci&oacute;n de sesiones</h1>
  <hr />
  <div class="d-flex flex-wrap my-2 container">
    <div class="col-12 col-md-8 d-flex align-items-end mb-2 mb-md-0">
      <div class="d-flex flex-wrap mx-2 align-items-center">
        <span class="mx-2">Eventos:</span>
        <div
          *ngFor="let colorRef of labelColorDesc"
          class="d-flex mx-2 align-items-center">
          <div
            [id]="'box' + colorRef.statusType + colorRef.processId"
            class="color-box"
            [ngStyle]="{ 'background-color': colorRef.color }"></div>
          <label
            [for]="'box' + colorRef.statusType + colorRef.processId"
            class="mb-0"
            >{{ colorRef.label }}</label
          >
        </div>
      </div>
    </div>
    <div
      class="col-12 col-md-4 d-flex justify-content-md-end justify-content-end">
      <a class="btn btn-primario btn-pequeno" (click)="addSession()">
        <span>Añadir Sesión</span>
      </a>
    </div>
  </div>

  <app-general-empty-modal
    #modalNewSession
    [modalConfig]="modalConfig"
    id="newSessionOut">
    <ng-container *ngIf="renderModal">
      <app-modal-add-sessionv2
        (closeModalEmitter)="closeModal($event)"
        [currentEventSelected]="null"></app-modal-add-sessionv2>
    </ng-container>
  </app-general-empty-modal>
  <app-full-calendar-component></app-full-calendar-component>
</div>
